import { render, staticRenderFns } from "./LoadingFrames.vue?vue&type=template&id=f8ddedfa&scoped=true"
import script from "./LoadingFrames.vue?vue&type=script&lang=js"
export * from "./LoadingFrames.vue?vue&type=script&lang=js"
import style0 from "./LoadingFrames.vue?vue&type=style&index=0&id=f8ddedfa&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8ddedfa",
  null
  
)

export default component.exports